(ns client-portal.client.drive-thru.locations.individual.views
  (:require [client-portal.client.layout :as l]
            [client-portal.client.drive-thru.locations.individual.data :as d]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [clojure.string :as s]
            [shared.core.components.components :as c]
            [shared.core.components.icon :as icon]
            [shared.core.util :as util]))

(defn key-value [{:keys [style k v]}]
  [:div {:style style}
   [c/theme
    :span {:style {:color (style/color :gray :base)
                   :font-size 14
                   :font-weight style/font-bold-weight}
           :theme (style/dark-style {:color (style/dark-color :on-background :base)})}
    (str k ":")]
   (into [c/theme
          :span {:style {:color (style/color :gray :base)
                         :font-size 14
                         :margin-left 5}
                 :theme (style/dark-style {:color (style/dark-color :on-background :base)})}]
         [(cond
            (vector? v) v
            (s/blank? v) "-"
            :else v)])])

(defmethod c/modal-view
  :locations/manage-volume-modal [_ _]
  (let [manage-volume- (re/subscribe [:locations/manage-volume-])]
    (fn [_ {:keys [volume-lane-speaker volume-lane-microphone volume-headset-speaker volume-headset-microphone volume-ai-speaker mac-address] :as args}]
      [c/modal {:animate? false
                :background-click nil}
       [c/form {:header "Edit Volume Settings"
                :sub-header (str "For " mac-address)
                :form-path d/location-volume-path
                :match-label-placeholder? true
                :fields [{:kind :input
                          :form-name :volume-lane-speaker
                          :label "Lane Speaker"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value volume-lane-speaker}
                          {:kind :input
                          :form-name :volume-lane-microphone
                          :label "Lane Microphone"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value volume-lane-microphone}
                          {:kind :input
                          :form-name :volume-headset-speaker
                          :label "Headset Speaker"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value volume-headset-speaker}
                          {:kind :input
                          :form-name :volume-headset-microphone
                          :label "Headset Microphone"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value volume-headset-microphone}
                          {:kind :input
                          :form-name :volume-ai-speaker
                          :label "AI Speaker"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value volume-ai-speaker}
                          ]
                :on-cancel #(re/dispatch [:modals/hide])
                :on-save #(re/dispatch [:locations/manage-volume-save args])
                }]])))

(defmethod c/modal-view
  :locations/manage-ngrok-modal [_ _]
  (let [manage-ngrok- (re/subscribe [:locations/manage-ngrok-])]
    (fn [_ {:keys [ngrok-http-ip-address ngrok-http-port ngrok-ssh-ip-address ngrok-ssh-port mac-address] :as args}]
      [c/modal {:animate? false
                :background-click nil}
       [c/form {:header "Edit Ngrok Settings"
                :sub-header (str "For " mac-address)
                :form-path d/location-ngrok-path
                :match-label-placeholder? true
                :fields [{:kind :input
                          :form-name :ngrok-http-ip-address
                          :label "HTTP Host/IP"
                          :input-type :string
                          :auto-focus true
                          :value ngrok-http-ip-address}
                          {:kind :input
                          :form-name :ngrok-http-port
                          :label "HTTP Port"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value ngrok-http-port}
                          {:kind :input
                          :form-name :ngrok-ssh-ip-address
                          :label "SSH Host/IP"
                          :input-type :string
                          :auto-focus true
                          :value ngrok-ssh-ip-address}
                          {:kind :input
                          :form-name :ngrok-ssh-port
                          :label "SSH Port"
                          :input-type :number
                          :min 0
                          :auto-focus true
                          :value ngrok-ssh-port}
                          ]
                :on-cancel #(re/dispatch [:modals/hide])
                :on-save #(re/dispatch [:locations/manage-ngrok-save args])
                }]])))

(defmethod c/modal-view
  :locations/manage-hardware-modal [_ _]
  (let [manage-hardware- (re/subscribe [:locations/manage-hardware-])]
    (fn [_ {:keys [software-version codec lane-microphone-type echo-cancel-type aggressiveness extra-noise-reduction echo-tail mac-address] :as args}]
      [c/modal {:animate? false
                :background-click nil}
       [c/form {:header "Edit Hardware Settings"
                :sub-header (str "For " mac-address)
                :form-path d/location-hardware-path
                :match-label-placeholder? true
                :fields [{:kind :input
                          :form-name :software-version
                          :label "Software Version"
                          :input-type :string
                          :auto-focus true
                          :value software-version}
                          {:kind :input
                          :form-name :codec
                          :label "CODEC"
                          :input-type :string
                          :auto-focus true
                          :value codec}
                          {:kind :input
                          :form-name :lane-microphone-type
                          :label "Lane Microphone Type"
                          :input-type :string
                          :auto-focus true
                          :value lane-microphone-type}
                          {:kind :input
                          :form-name :echo-cancel-type
                          :label "Echo Cancel Type"
                          :input-type :string
                          :auto-focus true
                          :value echo-cancel-type}
                          {:kind :input
                          :form-name :aggressiveness
                          :label "Aggressiveness"
                          :input-type :string
                          :auto-focus true
                          :value aggressiveness}
                          {:kind :input
                          :form-name :extra-noise-reduction
                          :label "Extra Noise Reduction"
                          :input-type :boolean
                          :auto-focus true
                          :value extra-noise-reduction}
                          {:kind :input
                          :form-name :echo-tail
                          :label "Echo Tail"
                          :auto-focus true
                          :input-type :number
                          :min 0
                          :value echo-tail}
                          ]
                :on-cancel #(re/dispatch [:modals/hide])
                :on-save #(re/dispatch [:locations/manage-hardware-save args])
                }]])))

(defmethod c/modal-view
  :locations/manage-sip-modal [_ _]
  (let [manage-sip- (re/subscribe [:locations/manage-sip-])]
    (fn [_ {:keys [sip-username sip-password sip-transport-type sip-server-address sip-outdial-number sip-from-header-replacement mac-address] :as args}]
      [c/modal {:animate? false
                :background-click nil}
       [c/form {:header "Edit SIP Settings"
                :sub-header (str "For " mac-address)
                :form-path d/location-sip-path
                :match-label-placeholder? true
                :fields [{:kind :input
                          :form-name :sip-username
                          :label "Username"
                          :input-type :string
                          :auto-focus true
                          :value sip-username}
                          {:kind :input
                          :form-name :sip-password
                          :label "Password"
                          :input-type :string
                          :auto-focus true
                          :value sip-password}
                          {:kind :input
                          :form-name :sip-transport-type
                          :label "Transport Type"
                          :input-type :string
                          :auto-focus true
                          :value sip-transport-type}
                          {:kind :input
                          :form-name :sip-server-address
                          :label "Server Address"
                          :input-type :string
                          :auto-focus true
                          :value sip-server-address}
                          {:kind :input
                          :form-name :sip-outdial-number
                          :label "Outdial Number"
                          :input-type :string
                          :auto-focus true
                          :value sip-outdial-number}
                          {:kind :input
                          :form-name :sip-from-header-replacement
                          :label "From Header Replacement"
                          :input-type :string
                          :auto-focus true
                          :value sip-from-header-replacement}
                          ]
                :on-cancel #(re/dispatch [:modals/hide])
                :on-save #(re/dispatch [:locations/manage-sip-save args])
                }]])))

(defmethod c/modal-view
  :locations/manage-network-modal [_ _]
  (let [manage-network- (re/subscribe [:locations/manage-network-])]
    (fn [_ {:keys [ip-address subnet-mask gateway dns-1 dns-2 switch-model switch-port-range mac-address] :as args}]
      [c/modal {:animate? false
                :background-click nil}
       [c/form {:header "Edit Network Settings"
                :sub-header (str "For " mac-address)
                :form-path d/location-network-path
                :match-label-placeholder? true
                :fields [{:kind :input
                          :form-name :ip-address
                          :label "IP Address"
                          :input-type :string
                          :auto-focus true
                          :value ip-address}
                          {:kind :input
                          :form-name :subnet-mask
                          :label "Subnet Mask"
                          :input-type :string
                          :auto-focus true
                          :value subnet-mask}
                          {:kind :input
                          :form-name :gateway
                          :label "Gateway"
                          :input-type :string
                          :auto-focus true
                          :value gateway}
                          {:kind :input
                          :form-name :dns-1
                          :label "DNS 1"
                          :input-type :string
                          :auto-focus true
                          :value dns-1}
                          {:kind :input
                          :form-name :dns-2
                          :label "DNS 2"
                          :input-type :string
                          :auto-focus true
                          :value dns-2}
                          {:kind :input
                          :form-name :dns-2
                          :label "DNS 2"
                          :input-type :string
                          :auto-focus true
                          :value dns-2}
                          {:kind :input
                          :form-name :switch-model
                          :label "Switch Model"
                          :input-type :string
                          :auto-focus true
                          :value switch-model}
                          {:kind :input
                          :form-name :switch-port-range
                          :label "Switch Port Range"
                          :input-type :string
                          :auto-focus true
                          :value switch-port-range}
                          ]
                :on-cancel #(re/dispatch [:modals/hide])
                :on-save #(re/dispatch [:locations/manage-network-save args])
                }]])))

(defmethod c/modal-view
  :locations/manage-external-doc-modal [_ _]
  (let [manage-external-doc- (re/subscribe [:locations/manage-external-doc-])]
    (fn [_ {:keys [external-documentation-folder location-id] :as args}]
      [c/modal {:animate? false
                :background-click nil}
       [c/form {:header "Edit Documentation Folder"
                :sub-header (str "For Location: " location-id)
                :form-path d/location-external-doc-path
                :match-label-placeholder? true
                :fields [{:kind :input
                          :form-name :external-documentation-folder
                          :label "External Documentation Folder"
                          :input-type :string
                          :auto-focus true
                          :value external-documentation-folder}
                          ]
                :on-cancel #(re/dispatch [:modals/hide])
                :on-save #(re/dispatch [:locations/manage-external-doc-save args])
                }]])))

(defn drive-thru-location-root []
  (let [cur-location- (re/subscribe [:drive-thru/location-by-current-route-concept-id-location-id-])]
    (fn [args]
      (let [location-id (:id @cur-location-)
            documentation-folder (:external-documentation-folder @cur-location-)
            edit-volume-settings #(re/dispatch [:manage-volume-settings %])
            external-doc-edit-fn #(re/dispatch [:locations/manage-external-doc {:location-id location-id :documnetation-folder documentation-folder}])
            
            ]
        [l/logged-in-with-header-nav (merge args
                                            {:data-loading? (util/loading? @cur-location-)
                                             :go-back-nav? true
                                             :go-back-label "All Locations"
                                             :go-back-nav-route [:drive-thru/locations-list]})
                                        
         [:div {:style {:display :flex
                        :align-items :center}}
          [c/h2 {} (:label @cur-location-)]]
         
         [:div "Address: " (:street-address @cur-location-) ", " (:city @cur-location-) " " (:state-code @cur-location-) ", " (:postal-code @cur-location-)]
         [:div "pos-id: " (:pos-id @cur-location-)]
         [:div "location-id: " location-id]
         [:div "brand-location-id: " (:brand-location-id @cur-location-)]       
         [:div "sip-hardware-mac-address: " (:sip-hardware-mac-address @cur-location-)]
         [:div "sip-hardware-type: " (:sip-hardware-type @cur-location-)]
         [:div "drive-thru_system-type: " (:drive-thru-system-type @cur-location-)]
         [:div [:div {:style {:display :inline-block}} "external-documentation-folder: " (:external-documentation-folder @cur-location-)] 
         (icon/action-material-icon {:icon-type :edit :on-click external-doc-edit-fn :style {:display :inline-block}})]
         
         
         
         [:div {:style {:display :flex
                        :align-items :center}}
          [c/h3 {} "Network"]]
         
         [c/table {:style {:margin-top 10}
                   :loading? (util/loading? @cur-location-)
                   :headers ["IP Address" "Subnet Mask", "Gateway", "DNS1", "DNS2", "Switch Model", "Switch Port Range"]
                   :rows (map (fn [{:keys [ip-address subnet-mask gateway dns-1 dns-2 switch-model switch-port-range mac-address] :as data}]
                                (let [network-edit-fn #(re/dispatch [:locations/manage-network
                                  (select-keys data [:ip-address :subnet-mask :gateway :dns-1 :dns-2 :switch-model :switch-port-range])
                                   mac-address])]
                                {:cells [ip-address subnet-mask gateway dns-1 dns-2 switch-model switch-port-range]
                                   :on-click network-edit-fn
                                   :actions [{:icon-type :edit :on-click network-edit-fn :tooltip-content "Edit"}]}))
                              [@cur-location-])
                   }]
         [:br]

         
         
         [:div {:style {:display :flex
                        :align-items :center}}
          [c/h3 {} "Ngrok"]]
         
         [c/table {:style {:margin-top 10}
                   :loading? (util/loading? @cur-location-)
                   :headers ["HTTP" "SSH"]
                   :rows (map (fn [{:keys [ngrok-http-ip-address ngrok-http-port ngrok-ssh-ip-address ngrok-ssh-port mac-address] :as ngrok-data}]
                                (let [ngrok-edit-fn #(re/dispatch [:locations/manage-ngrok
                                                    (select-keys ngrok-data [:ngrok-http-ip-address :ngrok-http-port :ngrok-ssh-ip-address :ngrok-ssh-port])
                                                    mac-address])]

                                {:cells [(str "http://" ngrok-http-ip-address ":" ngrok-http-port)
                                         (str "ssh://" ngrok-ssh-ip-address ngrok-ssh-port)]
                                   :on-click ngrok-edit-fn
                                   :actions [{:icon-type :edit :on-click ngrok-edit-fn :tooltip-content "Edit"}]}))
                              [@cur-location-])
                   }]
         
         [:br]
         
         [:div {:style {:display :flex
                        :align-items :center}}
          [c/h3 {} "Volume Settings"]]
         [c/table {:style {:margin-top 10}
                   :loading? (util/loading? @cur-location-)
                   :headers ["Lane Speaker", "Lane Microphone", "Headset Speaker", "Headset Microphone", "AI Speaker"]
                   :rows (map (fn [{:keys [volume-lane-speaker volume-lane-microphone volume-headset-speaker volume-headset-microphone volume-ai-speaker mac-address] :as volume-data}]
                                (let [volume-edit-fn #(re/dispatch [:locations/manage-volume 
                                                             (select-keys volume-data [:volume-lane-speaker :volume-lane-microphone :volume-headset-speaker :volume-headset-microphone :volume-ai-speaker])
                                                             mac-address])]
                                  {:cells [volume-lane-speaker volume-lane-microphone volume-headset-speaker volume-headset-microphone volume-ai-speaker]
                                   :on-click volume-edit-fn
                                   :actions [{:icon-type :edit :on-click volume-edit-fn :tooltip-content "Edit"}]}))
                              [@cur-location-])
                   }]
         
         [:br]
         [:div {:style {:display :flex
                        :align-items :center}}
          [c/h3 {} "Hardware"]]
         
         [c/table {:style {:margin-top 10}
                   :loading? (util/loading? @cur-location-)
                   :headers ["Software Version", "Codec", "Microphone Type", "Echo Cancel Type", "Aggressiveness", "Extra Noise Reduction", "Echo Tail"]
                   :rows (map (fn [{:keys [software-version codec lane-microphone-type echo-cancel-type aggressiveness extra-noise-reduction echo-tail mac-address] :as data}]
                                 (let [hardware-edit-fn #(re/dispatch [:locations/manage-hardware
                                                             (select-keys data [:software-version :codec :lane-microphone-type :echo-cancel-type :aggressiveness :extra-noise-reduction :echo-tail])
                                                             mac-address])]
                                {:cells [software-version codec lane-microphone-type echo-cancel-type aggressiveness (str extra-noise-reduction) echo-tail]
                                                                 :on-click hardware-edit-fn
                                   :actions [{:icon-type :edit :on-click hardware-edit-fn :tooltip-content "Edit"}]}))
                              [@cur-location-])
                   }]
         
         [:br]

         [c/h3 {} "SIP Settings"]

         [c/table {:style {:margin-top 10}
                   :loading? (util/loading? @cur-location-)
                   :headers ["Username" "Password" "Transport Type" "Server Address" "Outdial Number" "From Header Replacement"]
                   :rows (map (fn [{:keys [sip-username sip-password sip-transport-type sip-server-address sip-outdial-number sip-from-header-replacement mac-address] :as data}]
                                (let [sip-edit-fn #(re/dispatch [:locations/manage-sip
                                                            (select-keys data [:sip-username :sip-password :sip-transport-type :sip-server-address :sip-outdial-number :sip-from-header-replacement])
                                                             mac-address])]

                                {:cells [sip-username sip-password sip-transport-type sip-server-address sip-outdial-number sip-from-header-replacement]
                                :on-click sip-edit-fn
                                :actions [{:icon-type :edit :on-click sip-edit-fn :tooltip-content "Edit"}]}))
                              [@cur-location-])
                   }]

         ]))))
